// Organ System Constants for Care360 Frontend
// Defines the seven organ systems used throughout the application

export const ORGAN_SYSTEMS = {
  NEUROLOGICAL: 'neurological',
  CARDIOVASCULAR: 'cardiovascular',
  RESPIRATORY: 'respiratory',
  METABOLIC: 'metabolic',
  FILTRATION: 'filtration',
  MUSCULOSKELETAL: 'musculoskeletal',
  IMMUNE: 'immune'
};

export const ORGAN_SYSTEM_DISPLAY_NAMES = {
  [ORGAN_SYSTEMS.NEUROLOGICAL]: 'Neurological',
  [ORGAN_SYSTEMS.CARDIOVASCULAR]: 'Cardiovascular',
  [ORGAN_SYSTEMS.RESPIRATORY]: 'Respiratory',
  [ORGAN_SYSTEMS.METABOLIC]: 'Metabolic',
  [ORGAN_SYSTEMS.FILTRATION]: 'Filtration',
  [ORGAN_SYSTEMS.MUSCULOSKELETAL]: 'Musculoskeletal',
  [ORGAN_SYSTEMS.IMMUNE]: 'Immune'
};

export const ORGAN_SYSTEM_DESCRIPTIONS = {
  [ORGAN_SYSTEMS.NEUROLOGICAL]: 'Brain & Nervous System',
  [ORGAN_SYSTEMS.CARDIOVASCULAR]: 'Heart & Blood Vessels',
  [ORGAN_SYSTEMS.RESPIRATORY]: 'Lungs & Airways',
  [ORGAN_SYSTEMS.METABOLIC]: 'Liver & Metabolism',
  [ORGAN_SYSTEMS.FILTRATION]: 'Kidneys & Filtration',
  [ORGAN_SYSTEMS.MUSCULOSKELETAL]: 'Muscles, Bones & Joints',
  [ORGAN_SYSTEMS.IMMUNE]: 'Immune System & Defense'
};

export const ORGAN_SYSTEM_ICONS = {
  [ORGAN_SYSTEMS.NEUROLOGICAL]: '/icons/Neurological icon.png',
  [ORGAN_SYSTEMS.CARDIOVASCULAR]: '/icons/Cardiovascular icon.png',
  [ORGAN_SYSTEMS.RESPIRATORY]: '/icons/Respiratory icon.png',
  [ORGAN_SYSTEMS.METABOLIC]: '/icons/Metabolic icon.png',
  [ORGAN_SYSTEMS.FILTRATION]: '/icons/Filtration icon.png',
  [ORGAN_SYSTEMS.MUSCULOSKELETAL]: '/icons/Musculoskeletal icon.png',
  [ORGAN_SYSTEMS.IMMUNE]: '/icons/Immune icon.png'
};

// Array of all organ systems for validation and iteration
export const ORGAN_SYSTEM_LIST = Object.values(ORGAN_SYSTEMS);

// Helper function to get organ system display information
export const getOrganSystemInfo = (systemKey) => {
  return {
    key: systemKey,
    name: ORGAN_SYSTEM_DISPLAY_NAMES[systemKey],
    description: ORGAN_SYSTEM_DESCRIPTIONS[systemKey],
    iconPath: ORGAN_SYSTEM_ICONS[systemKey]
  };
};

// Helper function to get all organ systems with display information
export const getAllOrganSystems = () => {
  return ORGAN_SYSTEM_LIST.map(systemKey => getOrganSystemInfo(systemKey));
};

// Validation function
export const isValidOrganSystem = (systemKey) => {
  return ORGAN_SYSTEM_LIST.includes(systemKey);
};

// Color mapping for organ systems (matching health overview)
export const ORGAN_SYSTEM_COLORS = {
  [ORGAN_SYSTEMS.NEUROLOGICAL]: '#8B5CF6',
  [ORGAN_SYSTEMS.CARDIOVASCULAR]: '#EF4444', 
  [ORGAN_SYSTEMS.RESPIRATORY]: '#06B6D4',
  [ORGAN_SYSTEMS.METABOLIC]: '#F59E0B',
  [ORGAN_SYSTEMS.FILTRATION]: '#10B981',
  [ORGAN_SYSTEMS.MUSCULOSKELETAL]: '#6366F1',
  [ORGAN_SYSTEMS.IMMUNE]: '#EC4899'
};

// Helper function to get organ system with color
export const getOrganSystemWithColor = (systemKey) => {
  return {
    ...getOrganSystemInfo(systemKey),
    color: ORGAN_SYSTEM_COLORS[systemKey]
  };
};
